<template>
  <div class="richTextEditorWrapper">
    <editor v-if="showEditor" api-key="" :init="editorConfig" v-model="content" @input="updateValue" />
    <b-spinner v-else class="align-middle"></b-spinner>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
  name: 'rich-text-editor',
  props: ['initialContent'],
  components: {
    editor: Editor
  },
  data() {
    return {
      content: '',
      editorConfig: {
        license_key: 'gpl',
        language: 'pt_BR',
        height: 300,
        menubar: false,
        plugins: 'lists link image charmap table',
        toolbar:
          'undo redo | formatselect | fontselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat',
      },
      showEditor: false,
    };
  },
  methods: {
    async loadTinyMCE() {
      const scriptId = 'tinymce-script';

      if (document.getElementById(scriptId)) {
        this.showEditor = true
        return; // Script is already loaded
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.src = `/tinymce/tinymce.min.js`;
      script.onload = () => {
        console.log('TinyMCE Script loaded successfully');
        // Initialize TinyMCE or do any action needed after the script is loaded
        this.showEditor = true
      };

      document.head.appendChild(script);
    },
    updateValue(value) {
      this.content = value;
      this.$emit('update-value', this.content);
    },
  },
  mounted() {
    this.content = this.initialContent;
    this.loadTinyMCE();
    //setTimeout(() => { this.showEditor = true }, 200);
  }
};
</script>